import { Typography } from '@mui/material';

/** A failed read of the stored settings, shown where the value would be: never a value in its place (FE-14). */
const StoredReadFailed = () => (
  <Typography variant="caption" color="error.main" sx={{ display: 'block' }}>
    Could not read the stored settings
  </Typography>
);

export default StoredReadFailed;
